import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { enqueueSnackbar } from 'notistack';

import Logo from 'src/components/logo';
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { bgBlur } from 'src/theme/css';
import { axiosInstance, endpoints } from 'src/utils/axios';

import { useWhitelabelStore } from 'src/store/whitelabel/whitelabel.store';
import { useMeStore } from 'src/store/me/me.store';
import { IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import Iconify from 'src/components/iconify';
import { useAuthStore } from 'src/auth/store/auth.store';
import { useNavigate } from 'react-router-dom';
import { paths } from 'src/routes/paths';
import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();
  const navigate = useNavigate();

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const me = useMeStore((state) => state.me);

  const canResetRouletteSpins = me?.id === '69b1b192b562eeecdde925a3';

  const handleResetRouletteSpins = async () => {
    try {
      const response = await axiosInstance.post(endpoints.webapp.roulette.spins.deleteByUser('6981ef849303eaae10a9d7e9'));

      const deletedCount = response?.data?.deletedCount ?? 0;
      enqueueSnackbar(`Giros da roleta resetados com sucesso. Quantidade removida: ${deletedCount}.`, {
        variant: 'success',
      });
    } catch (error: any) {
      let errorMessage = 'Erro ao resetar giros da roleta.';

      if (typeof error?.error === 'string') {
        errorMessage = error.error;
      } else if (typeof error?.message === 'string') {
        errorMessage = error.message;
      }

      enqueueSnackbar(errorMessage, { variant: 'error' });
    }
  };

  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo customLogo={useWhitelabelStore.getState().whitelabel?.logo ?? '/logo/logo-nectar-laranja.png'} />
        {isAuthenticated && (
          <Stack direction="row" spacing={1} alignItems="center">
            {canResetRouletteSpins && (
              <Button
                size="small"
                variant="contained"
                onClick={handleResetRouletteSpins}
                sx={{
                  backgroundColor: theme.palette.error.main,
                  color: theme.palette.error.contrastText,
                  textTransform: 'none',
                  mr: 2,
                  '&:hover': {
                    backgroundColor: theme.palette.error.dark,
                  },
                }}
              >
                RESETAR GIROS DA ROLETA DO USUÁRIO 220448 (test-only)
              </Button>
            )}
            <Typography variant="h6">{me?.name}</Typography>
            <IconButton
              size="small"
              onClick={async () => {
                await useAuthStore.getState().logout();
                navigate(paths.auth.login);
              }}
            >
              <Iconify icon="material-symbols:logout" color={theme.palette.error.main} />
            </IconButton>
          </Stack>
        )}
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
